import DOMPurify from "dompurify";
import cn from "classnames";
import { Text } from "@rshbintech.dboul/core-ui";
import commonStyles from "../../../styles.scss";
import { StepsBlockProps } from "./types";
import styles from "./styles.scss";

export const StepsBlock = ({ title, steps }: StepsBlockProps) => (
  <div className={styles.block}>
    {!!title && (
      <h4
        className={styles["block-title"]}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(title),
        }}
      />
    )}
    <div
      className={styles["block-content"]}
      style={{
        marginTop: title ? "48px" : "0",
      }}
    >
      {steps.map((step, index) => (
        <div className={styles["block-step"]} key={step.id}>
          <div className={styles["block-step-button"]}>
            <Text size="medium" className={styles["block-step-button-text"]}>
              {index + 1}
            </Text>
          </div>
          <div className={styles["block-step-text"]}>
            <p
              className={cn(
                styles["block-step-title"],
                commonStyles["size-medium-long"]
              )}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(step.title),
              }}
            />
            <p
              className={cn(
                styles["block-step-desc"],
                commonStyles["size-medium-long"]
              )}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(step.text),
              }}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
);
